import * as yup from 'yup'

export const LicenceTypeValidation = yup.string()
